const findIndex = (array: any[], value: { id: any; }) => array.map((data: { id: any; }) => data.id).indexOf(value.id);

const findIndexOfObject = (array: any[], key: string | number, value: any) => array.map((data: { [x: string]: any; }) => data[key]).indexOf(value);

export default {
  findIndex,
  findIndexOfObject
};

